import React, { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';

import { sendSMS } from 'src/api/api';
import { mobilePhoneRegex, digitRegex, getLocalStorageValue } from 'src/utilis/utilis';
import { StorageKeys } from 'src/types/global';

import styles from './Phone.style';

interface Props {
    onSubmit: (p: string, newDeviceToken: string) => void;
    onError: (errorMassage: string) => void;
}

const TOAST_DURATION_S = 6;

const Phone = ({ onSubmit, onError }: Props): JSX.Element => {
    const { t } = useTranslation();
    const [phone, setPhone] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [isPresstine, setPresstine] = useState(true);
    const [lockedUntil, setLockedUntil] = useState<Date | null>(null);
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    useEffect(() => {
        if (!lockedUntil) return;

        let ticks = 0;
        const interval = setInterval(() => {
            ticks++;
            const remaining = lockedUntil.getTime() - Date.now();
            if (remaining <= 0 || ticks >= TOAST_DURATION_S) {
                clearInterval(interval);
                setLockedUntil(null);
                return;
            }
            const minutes = Math.floor(remaining / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            const timeLeft = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            onErrorRef.current(`${t('smsPunishmentLocked')} ${timeLeft} ${t('minutes')}`);
        }, 1000);

        return () => clearInterval(interval);
    }, [lockedUntil, t]);

    const onSendSMS = async (e: FormEvent) => {
        e.preventDefault();
        try {
            setisLoading(true);
            const deviceToken = getLocalStorageValue(StorageKeys.DeviceToken);
            const res = await sendSMS({ deviceToken, userMobile: phone });
            // const res = await sendSMS({ userMobile: phone });

            setisLoading(false);

            if (res.data.response === '0') {
                const newDeviceToken = res.data.$deviceToken;
                onSubmit(phone, newDeviceToken);
                return;
            }

            if (res.data.response === '2') {
                onError(t('phoneNumberWasntFound'));
                return;
            }

            if (res.data.response === '9') {
                onError(t('smsPunishment'));
                return;
            }

            if (res.data.response === 51 || res.data.response === '51') {
                const lockedUntilUTC = res.data.data?.lockedUntilUTC;
                if (lockedUntilUTC) {
                    const lockDate = new Date(lockedUntilUTC);
                    const remaining = lockDate.getTime() - Date.now();
                    const minutes = Math.floor(remaining / 60000);
                    const seconds = Math.floor((remaining % 60000) / 1000);
                    const timeLeft = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                    onError(`${t('smsPunishmentLocked')} ${timeLeft} ${t('minutes')}`);
                    setLockedUntil(lockDate);
                } else {
                    onError(t('smsPunishment'));
                }
                return;
            }

            onError(t('genralError'));
        } catch (error) {
            setisLoading(false);
            onError(t('genralError'));
            console.log('e', error);
        }
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPresstine(false);
        if (!digitRegex.test(e.target.value) && e.target.value) {
            e.preventDefault();
            return;
        }

        setPhone(e.target.value);
    };

    return (
        <styles.Form onSubmit={onSendSMS}>
            <styles.Center>
                <styles.Text>{t('typePhoneNumber')}</styles.Text>
                <styles.Input
                    autoFocus
                    error={!mobilePhoneRegex.test(phone) && !isPresstine}
                    inputProps={{
                        style: { textAlign: 'center', fontSize: 18 },
                        maxLength: 10,
                    }}
                    value={phone}
                    onChange={handleChange}
                />
            </styles.Center>
            <styles.Button
                disabled={!mobilePhoneRegex.test(phone)}
                color="primary"
                variant="contained"
                size="large"
                type="submit"
            >
                {/* TODO */}
                {false ? (
                    <div>
                        <CircularProgress color="inherit" size={26} />
                    </div>
                ) : (
                    t('enterTheSystem')
                )}
            </styles.Button>
        </styles.Form>
    );
};

export default Phone;
